import { Divider, List, MenuItem, Popover } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetMyInfoQuery } from "../../apis/users";
import { useAppDispatch } from "../../hooks/useRedux";
import { logout } from "../../redux/reducers/auth";

interface Props {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLButtonElement | null;
}
const AccountPopover = ({ open, onClose, anchorEl }: Props) => {
  const { data: profile } = useGetMyInfoQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClickAccont = () => {
    navigate("/mypage");
    onClose();
  };

  const handleClickSignout = () => {
    dispatch(logout());
    onClose();
  };

  const handleClickClients = () => {
    navigate("/clients");
    onClose();
  };

  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorOrigin={{
        horizontal: "left",
        vertical: "bottom",
      }}
      anchorEl={anchorEl}
    >
      <List>
        <MenuItem>{profile?.name}</MenuItem>
        <MenuItem sx={{ color: (theme) => theme.palette.text.secondary }}>
          {profile?.email}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleClickClients}>My Clients</MenuItem>
        <MenuItem onClick={handleClickAccont}>Account Setting</MenuItem>
        <MenuItem sx={{ color: (theme) => theme.palette.error.main }} onClick={handleClickSignout}>
          Sign out
        </MenuItem>
      </List>
    </Popover>
  );
};

export default AccountPopover;
